module.exports = __webpack_public_path__ + "static/media/declaration-form-step3.9aabfb17.svg";